module.exports = __webpack_public_path__ + "static/doctorHero-b7d15f8bf80a3ea9fc3a6047390c2605.png";